<div class="ion-page" [formGroup]="RecoveryForm" autocomplete="off">
    <ion-header>
        <upp-header color="primary" height="62px">
            <upp-header-content>
                <ion-label>{{tr('@login_recover_password_title')}}</ion-label>
            </upp-header-content>  
            <upp-header-button uppDataid="recover-close-button" (click)="CloseView()">
                <ion-icon name="close-outline"></ion-icon>
            </upp-header-button>                  
        </upp-header>
    </ion-header>
    <ion-content [scrollY]="false">
        <upp-scrollable class="auth-scroll">
            <div style="margin: 0px 2px">
                <div class="greeting" [class.mobile]="view.Mobile">
                    <h1>{{tr('@recover_lost_password')}}</h1>
                    <h2>{{tr('@recover_provide_email')}}</h2>
                </div>
                <div class='recover-form'>
                    <ion-list>
                        <ion-item lines="none">
                            <upp-input uppDataid="recover-mail-text" 
                                formControlName="usermail" 
                                type='email' 
                                autocomplete="username" 
                                placeholder="{{tr('@recover_usermail_placeholder')}}" 
                                title="{{tr('@recover_usermail')}}"
                                [errornfo]="{ required: tr('@mandatory_field'), email: tr('@enter_valid_email') }"
                            ></upp-input>
                        </ion-item>        
                    </ion-list>
                </div>
            </div>
        </upp-scrollable>
    </ion-content>
    <ion-footer mode='ios'>
        <ion-grid>
            <ion-row>
                <ion-col class="ion-align-self-stretch">
                    <ion-button uppDataid="recover-cancel-button" color="medium" expand="block" (click)="CloseView()">
                        {{tr('@recover_do_cancel_button')}}
                    </ion-button>
                </ion-col>
                <ion-col class="ion-align-self-stretch"> 
                    <ion-button uppDataid="recover-submit-button" color="primary" [disabled]="!RecoveryForm.valid" (click)="DoRecover()">
                        {{tr('@recover_do_recover_button')}}
                    </ion-button>
                </ion-col>
            </ion-row>        
        </ion-grid>    
    </ion-footer>
</div>
